import React, { useEffect, useState, useCallback, useRef } from "react";
import Dropdown from "../../../../components/common/dropdown";
import Button from "../../../../components/common/button";
import Addicon from "../../../../assets/icons/Addicon.svg";
import { promoDealCode } from "./../../../../share/constants/enums";
import { colors } from "./../../../../share/constants/enums";
import {
  Form,
  message,
  Input as InputField,
  Pagination,
  Spin,
  InputNumber,
  Input,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchService,
  fetchServiceCategory,
  fetchSubServiceCategory,
} from "../../../../store/slices/serviceSlice";
import { teslaService } from "./../../../../share/constants/enums";
import TextArea from "../../../../components/common/textArea";
import DealCard from "../../../../components/addDeal/dealCard";
import {
  getSsubService,
  getSubService,
  postService,
  updateService,
} from "../../../../api/service";
import DeleteMemberModal from "../../../../components/common/modalMember";
import { deleteDealCard, serviceImage } from "../../../../api/settings";
import {
  CloseCircleOutlined,
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import HandleFaqComponent from "../../../../components/common/faq";

const ChildServices = () => {
  // Initializations
  const dispatch = useDispatch();
  const scrollRef = useRef();
  const [form] = Form.useForm();

  // States
  const [inputFields, setInputFields] = useState([]);
  const [deleteId, setDeleteId] = useState();
  const [isDeleted, setIsDeleted] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [renderOnSave, setRenderOnSave] = useState(false);
  const [loader, setLoader] = useState(false);
  const [editedCard, setEditedCard] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [serviceObj, setServiceObj] = useState(["", ""]);
  const [showTesla, setShowTesla] = useState(false);
  const [pageSize, setPagesize] = useState(3);
  // const [category, setCategory] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [iloader, setIloader] = useState(false);
  const [addedCards, setAddedCards] = useState([]);
  const [parent, setParent] = useState();
  const [service, setService] = useState([{ id: 0 }, { id: 1 }]);
  const [subService, setSubService] = useState();
  const [parentServices, setParentServices] = useState();
  const [faqInputs, setFaqInputs] = useState([
    {
      id: 0,
      question: "",
      answer: "",
    },
  ]);
  const [value, setValues] = useState({
    serviceDescription: "",
    serviceIncluded1: "",
    serviceIncluded2: "",
    isChild: true,
    FAQ: [
      {
        question: "",
        answer: "",
      },
    ],
    finePrint: "",
  });

  // Use Selector Hooks
  const stateData = useSelector((state) => {
    return state.service;
  });
  const subServiceCategories = stateData.value.subserviceCategory;
  const serviceCards = stateData.value.service;

  // Map or Find Functions
  serviceCards?.items?.map((obj) => obj.serviceName.name);
  const parentSelectedId = parentServices?.find((item) =>
    parent?.includes(item?.serviceName)
  );

  // Other Functions
  const showModal = (id) => {
    setIsModalOpen(true);
    setDeleteId(id);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getServiceCategories = useCallback(async () => {
    dispatch(fetchServiceCategory());
    dispatch(fetchSubServiceCategory());
  }, [dispatch]);

  const onFinish = (values) => {
    handleSaveButton(values);
    values.id = inputFields.length + 1;

    values.serviceInputs = [
      { id: 1, value: "" },
      { id: 2, value: "" },
    ];
    values.faqInputs = [
      { id: 1, value: "" },
      { id: 2, value: "" },
    ];

    setInputFields([values, ...inputFields]);
    setValues({
      ...values,
      ...value,
    });

    const newCard = {
      category: values.category,
      price: values.price,
      serviceName: values.serviceName,
      discount: values.discountAmount,
      isTeslaService: values.isTeslaService,
      promoDealType: values.promoDealType,
      isAppointment: values.isAppointment,
      // isChild: true,
      parentId: parentSelectedId?._id,
    };

    setAddedCards([...addedCards, newCard]);
  };

  const handleSizeChange = (current, size) => {
    setPagesize(size);
  };

  const hideModal = () => {
    setIsModalOpen(false);
  };

  const YesClickHandler = async () => {
    setIsModalOpen(false);
    try {
      const res = await deleteDealCard(deleteId);
      if (res) {
        message.success("Service Card Deleted!");
        form.resetFields();
        setRenderOnSave(!renderOnSave);
        setIsEditing(false);
        setValues({
          serviceDescription: "",
          serviceIncluded1: "",
          serviceIncluded2: "",
          FAQ: [
            {
              question: "",
              answer: "",
            },
          ],
          finePrint: "",
        });
        setFaqInputs([
          {
            id: 0,
            question: "",
            answer: "",
          },
        ]);
        setSelectedImage(null);
        setEditedCard(null);
        setIsDeleted(!isDeleted);
      }
    } catch (error) {
      message.error("Error in Deleting Deal Card");
    }
  };

  const handleTextOnChange = (val) => {
    setValues({ ...value, serviceDescription: val });
  };

  const handleService = (val, id, isEditing) => {
    if (isEditing) {
      let editServiceIncludes = [...editedCard?.includeService];

      editServiceIncludes[id] = val;
      const editedServiceWithIncludedServices = {
        ...editedCard,
        includeService: [...editServiceIncludes],
      };
      setEditedCard(editedServiceWithIncludedServices);
    } else {
      let includedServices = serviceObj;
      includedServices[id] = val;
      setServiceObj([...includedServices]);
    }
  };

  const handleRemoveService = (id) => {
    setServiceObj((prevService, ind) =>
      prevService.filter((service, index) => index !== id)
    );
  };

  const hadleRemoveservicewhileediting = (id) => {
    const res = editedCard.includeService.filter((item, i) => i !== id);
    setEditedCard({ ...editedCard, includeService: res });
  };

  const handlefineprint = (val) => {
    setValues({ ...value, finePrint: val });
  };

  const handleDeleteUploadFileIcon = () => {
    setSelectedImage(null);
  };

  const updateServiceCards = (data) => {
    if (
      data?.subServiceCategoryId?.serviceCategoryId?._id ===
      "64e87bbeb2b8697561f80fec"
    ) {
      setShowTesla(true);
    }
    setRenderOnSave(!renderOnSave);
    form.setFieldsValue({
      discountAmount: data.discountAmount,
      serviceName: data.serviceName,
      category: data?.subServiceCategoryId,
      quantity: data.maxQuantity,
      price: data.servicePrice,
      isTeslaService: data.isTeslaService,
      // isChild: true,
      parentId: data?.parentId,
      promoDealCode: data.promoDealCode,
      serviceDescription: data.serviceDescription,
      FAQ: data?.FAQ?.map((val, i) => {
        return val;
      }),
      includeService: [...data?.includeService],
    });

    setValues({
      ...value,
      serviceDescription: data?.serviceDescription,
      finePrint: data?.finePrint,
      FAQ: data?.FAQ?.map((val) => {
        return val;
      }),
    });

    setEditedCard({
      ...data,
      serviceImage: data?.serviceImage
        ? data?.serviceImage
        : data?.serviceCategory?.image,
    });
    setFaqInputs(
      data?.FAQ?.map((val) => {
        return val;
      })
    );
    setIsEditing(true);
  };

  const handleSaveButton = async (values) => {
    try {
      setLoader(true);
      const newFaqArray = faqInputs.map((item) => {
        return { question: item.question, answer: item.answer };
      });
      if (isEditing) {
        if (typeof values?.category === "object") {
          values.category = values.category?._id;
        }
        const payload = {
          serviceName: values.serviceName ?? editedCard.serviceName,
          subServiceCategoryId:
            values?.category ?? editedCard?.subServiceCategoryId?._id,
          servicePrice: values.price ?? editedCard.servicePrice,
          discount: values.discountAmount ?? editedCard.discountAmount,
          isTeslaService: values.isTeslaService ?? editedCard.isTeslaService,
          isAppointment: values.isAppointment ?? editedCard.isAppointment,
          finePrint: value.finePrint ?? editedCard.finePrint,
          maxQuantity: values.quantity ?? editedCard.maxQuantity,
          promoDealType: values.promoDealType ?? editedCard.promoDealType,
          parentId: parentSelectedId?._id ?? editedCard?.parentId,
          serviceDescription:
            value.serviceDescription ?? editedCard.serviceDescription,
          includeService: isEditing ? editedCard?.includeService : serviceObj,
          FAQ: newFaqArray.length
            ? newFaqArray
            : editedCard?.FAQ?.map((val) => {
                return val;
              }),
        };
        if (selectedImage) {
          payload.serviceImage = selectedImage ?? editedCard?.serviceImage;
        }
        const res = await updateService(editedCard?._id, payload);
        if (res) {
          message.success("Sub Service Updated Successfully");
          setRenderOnSave(!renderOnSave);
          setIsEditing(false);
          setEditedCard(null);
          setValues({
            serviceDescription: "",
            serviceIncluded1: "",
            serviceIncluded2: "",
            FAQ: [
              {
                question: "",
                answer: "",
              },
            ],
            finePrint: "",
          });
          form?.resetFields();
          setFaqInputs([
            {
              id: 0,
              question: "",
              answer: "",
            },
          ]);
          setSelectedImage(null);
        }
      } else {
        if (serviceObj[1] === "") {
          serviceObj.splice(1, 1);
        }
        const payload = {
          serviceName: values.serviceName,
          subServiceCategoryId: values.category,
          servicePrice: values.price,
          discount: values.discountAmount,
          isTeslaService: showTesla ? values.isTeslaService : false,
          maxQuantity: values.quantity,
          finePrint: value.finePrint,
          promoDealType: values.promoDealType,
          isChild: true,
          parentId: parentSelectedId?._id,
          serviceDescription: value.serviceDescription,
          includeService: serviceObj,
          isAppointment: values.isAppointment,
          FAQ: newFaqArray,
        };
        if (selectedImage) {
          payload.serviceImage = selectedImage;
        }
        const res = await postService(payload);
        if (res) {
          message.success("Sub Service Added Successfully");
          setRenderOnSave(!renderOnSave);
          setEditedCard(null);
          setValues({
            serviceDescription: "",
            serviceIncluded1: "",
            serviceIncluded2: "",
            isChild: true,
            parentId: "",
            FAQ: [
              {
                question: "",
                answer: "",
              },
            ],
            finePrint: "",
          });
          form.resetFields();
          setFaqInputs([
            {
              id: 0,
              question: "",
              answer: "",
            },
          ]);
          setSelectedImage(null);
        }
      }
    } catch (error) {
      console.error("Error while making API call:", error);
    } finally {
      setLoader(false);
    }
  };

  const handleChangeAndUploadImage = async (e) => {
    setIloader(true);
    const file = e.target.files[0];

    if (file) {
      const formData = new FormData();
      formData.append("image", file);

      try {
        const response = await serviceImage(formData);

        if (response?.url) {
          setSelectedImage(response?.url);
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      } finally {
        setIloader(false);
      }
    } else {
      setIloader(false);
    }
  };

  const handleAddIncludedServices = () => {
    if (isEditing) {
      if (editedCard?.includeService?.length > 0) {
        let editService = { ...editedCard };
        editService.includeService = [...editService?.includeService, ""];
        setEditedCard(editService);
      } else {
        setService([...service, { id: editedCard?.includeService?.length }]);
      }
    } else {
      setServiceObj([...serviceObj, ""]);
    }
  };

  const validateDiscount = (rule, value, callback) => {
    const { getFieldValue } = form;
    const servicePrice = getFieldValue("price");
    if (value > servicePrice) {
      callback("Discount amount cannot be greater than service price");
    } else {
      callback();
    }
  };
  const businessMaxQuantity = useSelector(
    (state) => state?.business?.business?.maxQuantity
  );
  // Use Effects
  useEffect(() => {
    const func = async () => {
      const values = await getSsubService();
      setParentServices(values);
    };
    func();
  }, []);

  useEffect(() => {
    if (isEditing) {
      setService([]);
    } else {
      setService([
        {
          id: 0,
        },
        {
          id: 1,
        },
      ]);
    }
  }, [isEditing]);
  const handleSelectingCategory = async (id) => {
    const selected = subServiceCategories?.find((item) => item?._id === id);

    // if (isEditing) {
    //   setEditedCard((prevCard) => ({
    //     ...prevCard,
    //     subServiceCategoryId: null,
    //   }));
    //   form.setFieldValue("subcategory", null);
    // }
    // const selected = subServiceCategories?.find((item) => item?._id === id);
    // setCategory(selected?.subServiceCategories);
    if (selected?.serviceCategoryId === "64e87bbeb2b8697561f80fec")
      setShowTesla(true);
    else setShowTesla(false);
  };
  useEffect(() => {
    const payload = {
      pageNumber: currentPage,
      pageSize: pageSize,
    };
    getServiceCategories();
    dispatch(fetchService(payload));
  }, [dispatch, renderOnSave]);
  const validateQuantity = (rule, value, callback) => {
    // const { getFieldValue } = form;
    // const serviceQuantity = getFieldValue("quantity");
    if (value > businessMaxQuantity) {
      callback(`Max Quantity cannot be greater than ${businessMaxQuantity}`);
    } else {
      callback();
    }
  };
  useEffect(() => {
    const func = async () => {
      const payload = {
        pageNumber: currentPage,
        pageSize: pageSize,
      };
      const subSer = await getSubService(payload);
      setSubService(subSer);
    };
    func();
  }, [renderOnSave, isEditing, isDeleted, currentPage, pageSize]);

  return (
    <>
      {stateData?.isLoading ? (
        <div className="h-screen w-full flex items-center justify-center">
          <Spin indicator={<LoadingOutlined />} />
        </div>
      ) : (
        <div className={`relative ${isModalOpen ? "blur-sm" : ""}`}>
          <div className="px-3" ref={scrollRef}>
            <div>
              <p className="text-lg font-medium tracking-wider">
                Add New Sub Services
              </p>
            </div>
            <div className="p-2 border-solid border-inputFieldGrey rounded-sm justify-center items-center">
              <div className="flex flex-col space-y-2 items-center mt-3 xl:items-start xl:space-y-0">
                <Form form={form} className="w-full" onFinish={onFinish}>
                  <div className="md:grid md:grid-cols-4 md:gap-2 ">
                    <Form.Item
                      name="category"
                      className="w-full rounded-md "
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <Dropdown
                        placeholder={"Sub-Service Category"}
                        onChange={handleSelectingCategory}
                        defaultValue={editedCard?.subServiceCategoryId?._id}
                        data={subServiceCategories}
                      />
                    </Form.Item>

                    <Form.Item
                      name="price"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                        {
                          pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
                          message: "Please enter a positive number",
                        },
                      ]}
                    >
                      <InputNumber
                        className={
                          "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg "
                        }
                        placeholder="$ Original Service Price"
                        type="number"
                        controls={false}
                        defaultValue={isEditing ? editedCard?.servicePrice : ""}
                      />
                    </Form.Item>

                    <Form.Item
                      name="serviceName"
                      className="w-full bg-inputFieldGrey rounded-md "
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <InputField
                        className={"w-full  hover:border-primaryBlue h-5.4  "}
                        placeholder="Service Name"
                        value={editedCard?.serviceName}
                      />
                    </Form.Item>

                    <Form.Item
                      name="discountAmount"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                        {
                          pattern: /^(0*[0-9]\d*(\.\d+)?|0+\.\d*[0-9]\d*)$/,
                          message: "Please enter a positive number",
                        },
                        {
                          validator: validateDiscount,
                        },
                      ]}
                    >
                      <InputNumber
                        className={
                          "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg"
                        }
                        placeholder="$ Discount Amount"
                        type="number"
                        controls={false}
                        defaultValue={
                          isEditing ? editedCard?.discountAmount : ""
                        }
                      />
                    </Form.Item>
                    <div
                      className="flex items-center rounded-md h-4"
                      name="image"
                    >
                      <label
                        htmlFor="imageUpload"
                        className="flex flex-col cursor-pointer border-solid border-inputFieldGrey rounded-md group-hover:text-white justify-center h-6 w-24.6 items-center bg-white hover:text-white text-primaryPurple border hover:bg-primaryPurple"
                      >
                        <PlusOutlined
                          className="justify-center"
                          style={{ fontSize: "18px" }}
                        />
                        Upload Service Image
                        <Input
                          type="file"
                          id="imageUpload"
                          accept="image/*"
                          className="h-6 w-6"
                          style={{ display: "none" }}
                          onChange={handleChangeAndUploadImage}
                        />
                      </label>
                      <div className="ml-2">
                        {iloader ? (
                          <div className="loader">
                            <Spin indicator={<LoadingOutlined />} />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {selectedImage && (
                        <div className="ml-2">
                          <DeleteOutlined
                            className="hover:cursor-pointer absolute ml-[45px] p-[2px] bg-white cover-object"
                            onClick={handleDeleteUploadFileIcon}
                          />
                          <img
                            src={selectedImage}
                            alt="Selected Service Image"
                            className="w-6 h-6 rounded-full"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="md:grid md:grid-cols-2 lg:grid lg:grid-cols-2 md:gap-2">
                    {showTesla && (
                      <div>
                        <p className="sm:line-clamp-1">
                          Do You Service Tesla Vehicles with this Service
                        </p>

                        <Form.Item
                          name="isTeslaService"
                          className="w-full rounded-md"
                        >
                          <Dropdown
                            data={teslaService}
                            placeholder={"Yes"}
                            defaultValue={editedCard?.isTeslaService}
                          />
                        </Form.Item>
                      </div>
                    )}
                    <div>
                      <p>Choose Appointment Type</p>
                      <Form.Item
                        name="promoDealType"
                        className="w-full rounded-md "
                      >
                        <Dropdown
                          data={promoDealCode}
                          placeholder={"Choose Appointment Type"}
                          defaultValue={editedCard?.promoDealType}
                        />
                      </Form.Item>
                    </div>
                    <div>
                      <p>Parent Service</p>

                      <Form.Item
                        name="parentId"
                        className="w-full rounded-md "
                        rules={[
                          {
                            required: true,
                            message: "This field is required",
                          },
                        ]}
                      >
                        <Dropdown
                          data={parentServices}
                          onChange={(e) => setParent(e)}
                          placeholder={"Parent Service"}
                          defaultValue={
                            editedCard &&
                            `${editedCard?.parent[0]?.serviceName} - Price:$${
                              editedCard?.parent[0]?.servicePrice
                            } - Discount: $${editedCard?.parent[0]?.discount?.toFixed(
                              2
                            )}`
                          }
                          subService={true}
                        />
                      </Form.Item>
                    </div>
                    <div>
                      <p>Max Quantity (1-{businessMaxQuantity})</p>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                          },
                          {
                            pattern: /^(0*[0-9]\d*(\.\d+)?|0+\.\d*[0-9]\d*)$/,
                            message: "Please enter a positive number",
                          },
                          {
                            validator: validateQuantity,
                          },
                        ]}
                        name="quantity"
                        className="w-full rounded-md "
                      >
                        <InputNumber
                          className={
                            "w-full  hover:border-primaryBlue h-5.4 flex items-center rounded-lg"
                          }
                          placeholder="Max Quantity"
                          type="number"
                          controls={false}
                          defaultValue={
                            isEditing ? editedCard?.maxQuantity : ""
                          }
                        />
                        {/* <Dropdown
                          placeholder={"Yes"}
                          data={teslaService}
                          // disabled={true}
                          defaultValue={editedCard?.isAppointment}
                        /> */}
                      </Form.Item>
                    </div>
                  </div>

                  <div>
                    <p>Service Description</p>
                    <Form.Item name="serviceDescription">
                      <TextArea
                        placeholder={"Service Description"}
                        handleTextChange={(value) => {
                          handleTextOnChange(value);
                        }}
                        text={value.serviceDescription}
                        className="w-full rounded-xl hover:border-primaryBlue"
                        rows={3}
                      />
                    </Form.Item>
                  </div>
                  <div>
                    <p>What's Included In The Service?</p>
                    <div>
                      <Form.Item name="includeService">
                        <div className="w-full md:grid md:grid-cols-2 gap-2 ">
                          {isEditing ? (
                            <>
                              {editedCard?.includeService?.map((val, i) => (
                                <div key={i} className="relative">
                                  <Input
                                    onChange={(e) =>
                                      handleService(e.target.value, i, true)
                                    }
                                    className="w-full hover:border-primaryBlue h-5.4 pr-8 "
                                    defaultValue={val}
                                  />
                                  <CloseCircleOutlined
                                    onClick={() =>
                                      hadleRemoveservicewhileediting(i)
                                    }
                                    className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                  />
                                </div>
                              ))}
                            </>
                          ) : (
                            serviceObj?.map((inputs, i) => {
                              return (
                                <div key={i} className="relative">
                                  <InputField
                                    placeholder="."
                                    onChange={(e) => {
                                      handleService(e.target.value, i, false);
                                    }}
                                    className="w-full hover:border-primaryBlue h-5.4 pr-8 "
                                  />

                                  {i >= 2 && (
                                    <CloseCircleOutlined
                                      onClick={() => handleRemoveService(i)}
                                      className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer"
                                    />
                                  )}
                                </div>
                              );
                            })
                          )}
                        </div>
                        <Button
                          color={colors.primaryPurple}
                          onClick={handleAddIncludedServices}
                          icon={Addicon}
                          title="Add"
                          htmlType={"button"}
                          className="w-full mt-2"
                        />
                      </Form.Item>
                    </div>
                    <div className="mt-2">
                      FAQ
                      <Form.Item name={"FAQ"} className="">
                        <div className="mt-1">
                          {isEditing
                            ? faqInputs?.map((val, i) => {
                                return (
                                  <HandleFaqComponent
                                    faqInputs={faqInputs}
                                    setFaqInputs={setFaqInputs}
                                    value={val}
                                    index={i}
                                  />
                                );
                              })
                            : faqInputs?.map((inputs, i) => {
                                return (
                                  <HandleFaqComponent
                                    faqInputs={faqInputs}
                                    setFaqInputs={setFaqInputs}
                                    value={inputs}
                                    index={i}
                                  />
                                );
                              })}
                        </div>
                      </Form.Item>
                      <Button
                        color={colors.primaryPurple}
                        onClick={() => {
                          setFaqInputs([
                            ...faqInputs,
                            { id: faqInputs.length, question: "", answer: "" },
                          ]);
                        }}
                        icon={Addicon}
                        title="Add"
                        htmlType={"button"}
                        className="w-full mt-2"
                      />
                    </div>

                    <div>
                      <p>Fine Print</p>
                      <TextArea
                        handleTextChange={(value) => {
                          handlefineprint(value);
                        }}
                        text={value.finePrint}
                        placeholder={"Fine Print"}
                        className="w-full rounded-xl hover:border-primaryBlue"
                        rows={3}
                      />
                    </div>
                  </div>
                  <div className="w-full flex justify-center lg:justify-end gap-2 mt-2 mb-4">
                    <Button
                      color={colors.primaryPurple}
                      title="Save"
                      htmlType={"submit"}
                      loading={loader}
                      className="w-19"
                    />
                  </div>
                </Form>
              </div>
            </div>

            {subService?.items?.length ? (
              <>
                <div>
                  <p style={{ color: "#5530C1" }} className="font-normal	">
                    * Manage Your Appointment Time Offers From Your Messages Tab
                  </p>

                  <p className="text-lg font-medium tracking-wider">
                    Active Sub-Service Cards
                  </p>
                </div>
                <div>
                  <div className="mt-2">
                    {subService?.items?.map((data, i) => {
                      return (
                        <div className="my-2 " key={i}>
                          <DealCard
                            openModal={() => showModal(data?._id)}
                            edit={() => {
                              scrollRef.current.scrollIntoView({
                                behavior: "smooth",
                              });
                              updateServiceCards(data);
                            }}
                            data={data}
                            isSubService={true}
                          />
                        </div>
                      );
                    })}
                  </div>
                  <div className="flex justify-center items-center pagination-container mb-2">
                    <Pagination
                      current={currentPage}
                      total={subService?.totalItems}
                      pageSize={pageSize}
                      pageSizeOptions={[3, 10, 20, 30]}
                      onShowSizeChange={handleSizeChange}
                      onChange={(e) => {
                        handlePageChange(e);
                      }}
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            {isModalOpen && (
              <DeleteMemberModal
                title="Delete Service Card"
                text="Do you want to Delete Service Card?"
                onCancel={hideModal}
                onOk={YesClickHandler}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ChildServices;
